import request from '@/utils/request'

/**
 * 查询场景元件
 * @param {Object} params 
 * @returns 
 */
export function listSceneComponent(params) {
  return request({
    url: '/component/scene_component/list',
    method: 'GET',
    params,
  })
}

/**
 * 查询场景元件
 * @param {Object} params 
 * @returns 
 */
export function findSceneStructInfo(params) {
  return request({
    url: '/component/scene_component/findSceneStructInfo',
    method: 'GET',
    params,
  })
}

/**
 * 添加场景元件
 * @param {Object} data 
 * @returns 
 */
export function insertSceneComponent(data) {
  return request({
    url: '/component/scene_component/insert',
    method: 'POST',
    data,
  })
}


/**
 * 修改场景元件
 * @param {Object} data 
 * @returns 
 */
export function updateSceneComponent(data) {
  return request({
    url: '/component/scene_component/update',
    method: 'POST',
    data,
  })
}


/**
 * 删除
 * @param {Object} data 
 * @returns 
 */
export function removeSceneComponent(data) {
  return request({
    url: '/component/scene_component/remove',
    method: 'POST',
    data,
  })
}


/**
 * 添加场景元件
 * @param {Object} data 
 * @returns 
 */
export function getSceneComponentById(data) {
  return request({
    url: '/component/scene_component/getById',
    method: 'get',
    data,
  })
}

